<!--
 * @Description: 公用的商户详情组件
 * @Author: sunhuihong
 * @Date: 2022-09-29 16:43:52
 * @LastEditTime: 2022-12-27 14:19:32
-->
<template>
  <div class="common-details-body" >
    <div class="section-item" v-if="mchDetailsData && mchDetailsData.merchant">
			<el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
				<el-descriptions-item label="所属机构">{{mchDetailsData.institutionName}}</el-descriptions-item>
				<el-descriptions-item label="商户简称">{{mchDetailsData.merchant.name}}</el-descriptions-item>
			</el-descriptions>
      <div class="common-details-tabs">
        <span :class="mchDetailsData.merchant.type == key ? 'active' : 'click-switch-list'"  
          v-for="(item,key) in typeMap" :key="key">
          {{item}}
        </span>
      </div>
    </div>
    <div class="section-item-title" v-if="mchDetailsData && mchDetailsData.merchant && mchDetailsData.merchant.type == 1">
      <div class="section-item-head">
		    <div class="blue-line"></div>
		    <span>营业执照信息</span>
		  </div>
      <div class="section-item">
			  <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
			  	<el-descriptions-item label="证件扫描件">
            <el-image class="common-details-img" v-if="mchDetailsData.merchant.bizLicenseImgPath"  
              :src="bizLicenseImgPath" fit="contain" :preview-src-list="previewImgList" />
						<span v-else>无</span>
          </el-descriptions-item>
			  	<el-descriptions-item label="证件注册号">{{mchDetailsData.merchant.bizLicenseNo}}</el-descriptions-item>
			  	<el-descriptions-item label="商户名称">{{mchDetailsData.merchant.fullname}}</el-descriptions-item>
			  </el-descriptions>
      </div>
    </div>
    <div class="section-item-title" v-if="mchDetailsData && mchDetailsData.merchant">
      <div class="section-item-head">
		    <div class="blue-line"></div>
		    <span>{{mchDetailsData.merchant.type == 1 ? '法人身份信息' : '经营者身份信息'}}</span>
		  </div>
      <div class="section-item">
			  <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
			  	<el-descriptions-item label="证件类型">
            {{mchDetailsData.merchant.idCardType == 1 ? '中国大陆居民-身份证' : '- -'}}
          </el-descriptions-item>
			  	<el-descriptions-item label="身份证人像照片">
            <el-image class="common-details-img" v-if="mchDetailsData.merchant.idCardImg1Path"  
              :src="idCardImg1Path" fit="contain" :preview-src-list="previewImgList" />
						<span v-else>无</span>
          </el-descriptions-item>
			  	<el-descriptions-item label="身份证国徽照片">
            <el-image class="common-details-img" v-if="mchDetailsData.merchant.idCardImg2Path"  
              :src="idCardImg2Path" fit="contain" :preview-src-list="previewImgList" />
						<span v-else>无</span>
          </el-descriptions-item>
			  	<el-descriptions-item label="身份证姓名">{{mchDetailsData.merchant.idCardName}}</el-descriptions-item>
			  	<el-descriptions-item label="身份证号">{{mchDetailsData.merchant.idCardNo}}</el-descriptions-item>
			  	<el-descriptions-item label="身份证居住地址">{{mchDetailsData.merchant.idCardAddr}}</el-descriptions-item>
			  	<el-descriptions-item label="身份证有效期">
            <span>{{mchDetailsData.merchant.idCardValidtyStart}}</span>
            <span v-if="mchDetailsData.merchant.idCardValidtyLongTerm == 0" >
              &nbsp;&nbsp;至&nbsp;&nbsp;{{mchDetailsData.merchant.idCardValidtyEnd}}
            </span>
            <el-checkbox v-model="mchDetailsData.merchant.idCardValidtyLongTerm" :true-label="1" :false-label="0" 
              style="margin-left:27px;" disabled>
              <span style="color:#000000;">长期有效</span>
            </el-checkbox>
          </el-descriptions-item>
			    <el-descriptions-item label="是否受益人">
            <el-radio v-model="mchDetailsData.merchant.isOwner" :label="mchDetailsData.merchant.isOwner"  disabled>
              <span style="color:#000000;">是</span>
            </el-radio>
          </el-descriptions-item>
			  </el-descriptions>
      </div>
    </div>
    <div class="section-item-title" v-if="mchDetailsData && mchDetailsData.bankAccount">
      <div class="section-item-head">
		    <div class="blue-line"></div>
		    <span>结算银行账户</span>
		  </div>
      <div class="section-item" >
			  <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
			  	<el-descriptions-item label="账户类型">
            {{mchDetailsData.bankAccount.type == 1 ? '对公账户' : mchDetailsData.bankAccount.type == 2 ? '对私账户' : '- -'}}
          </el-descriptions-item>
			  	<el-descriptions-item label="开户银行">{{mchDetailsData.bankAccount.bankName}}</el-descriptions-item>
			  	<el-descriptions-item label="开户银行全称(含支行)" v-if="mchDetailsData.bankAccount.bankNameDetail">
            {{mchDetailsData.bankAccount.bankNameDetail ? mchDetailsData.bankAccount.bankNameDetail : '- -'}}
          </el-descriptions-item>
			  	<el-descriptions-item label="开户名称">{{mchDetailsData.bankAccount.accountName}}</el-descriptions-item>
          <el-descriptions-item label="开户银行省市编码">
            {{mchDetailsData.bankAccount.regionDetail ? mchDetailsData.bankAccount.regionDetail : '- -'}}
          </el-descriptions-item>
			  	<el-descriptions-item label="银行账号">{{mchDetailsData.bankAccount.accountNo}}</el-descriptions-item>
			  </el-descriptions>
      </div>
    </div>
    <div class="section-item-title" v-if="mchDetailsData && mchDetailsData.merchant">
      <div class="section-item-head">
		    <div class="blue-line"></div>
		    <span>超级管理员信息</span>
		  </div>
      <div class="section-item">
			  <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
			  	<el-descriptions-item label="超级管理员类型">
            {{mchDetailsData.merchant.superAdminType == 1 ? '法人' : mchDetailsData.merchant.superAdminType == 2 ? '经营者' : '- -'}}
          </el-descriptions-item>
			  	<el-descriptions-item label="超级管理员手机">
            {{mchDetailsData.merchant.superAdminMobile == '' ? '- -' : mchDetailsData.merchant.superAdminMobile}}
          </el-descriptions-item>
			  	<el-descriptions-item v-if="mchDetailsData.merchant.type == 1" label="超级管理员邮箱">
            {{mchDetailsData.merchant.superAdminEmail == '' ?  '- -' : mchDetailsData.merchant.superAdminEmail}}
          </el-descriptions-item>
			  </el-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonMchDetails',
  props: ["mchDetailsData"],

  data() {
    return {
      labelStyle: {'margin-bottom': '10px', 'text-align': 'right', 'width': '150px'},
      contentStyle: {'margin-bottom': '10px'},
      detailsData: {},
      typeMap: {1: "企业", 2: "小微商户"},
    }
  },

  computed : {
    bizLicenseImgPath() {
      return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.bizLicenseImgPath);
    },

    idCardImg1Path() {
      return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.idCardImg1Path);
    },

    idCardImg2Path() {
      return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.idCardImg2Path);
    },

		previewImgList() {
      let imgList = [];
      if (this.mchDetailsData.merchant.bizLicenseImgPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.bizLicenseImgPath));
      }
      if (this.mchDetailsData.merchant.idCardImg1Path) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.idCardImg1Path));
      }
      if (this.mchDetailsData.merchant.idCardImg2Path) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.mchDetailsData.merchant.idCardImg2Path));
      }
      return imgList;
    }

  },
  
  methods: {

  },
}
</script>

<style scoped>
.common-details-body {
  padding: 30px 50px 0 50px;
  text-align: center;
  border: solid 0px;
}

.section-item {
  margin: 0 0 0 15px;
  text-align: left;
}

.section-item  /deep/ .el-descriptions-item__label {
	font-size: 14px;
	color: #657180;
  display: flex;
  align-items: center;
  justify-content: right;
}

.section-item  /deep/ .el-descriptions-item__content {
	font-size: 14px;
	color: #000000;
  display: flex;
  align-items: center;
}

.common-details-tabs {
  height: 32px;
  line-height: 32px;
  margin-top: 4px;
  margin-left: 92px;
}

.common-details-tabs .active{
  display: inline-block;
  width: 120px;
  height: 100%;
  text-align: center;
  background-color:  #3E7EF5;
  color: #FFFFFF;
  margin-top: -2px;
}

.common-details-tabs .click-switch-list{
  display: inline-block;
  width: 120px;
  height: 100%;
  text-align: center;
  color: #D7DDE5;
}

.common-details-tabs span:nth-child(1) {
  border: 1px solid #D7DDE5;
  border-radius: 4px 0 0 4px;
}

.common-details-tabs span:nth-child(2) {
  border: 1px solid #D7DDE5;
  border-radius: 0 4px 4px 0;
  border-left: none;
}

.common-details-body .section-item-title {
  margin-top: 30px;
}

.common-details-body .section-item-head {
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 30px;
}

.common-details-body .section-item-head span {
  font-size: 14px;
  color: #657180;
}

.common-details-body .blue-line {
  width: 5px;
  height: 20px;
  border-radius: 2px;
  background: #3E7EF5;
  margin-right: 9px;
}

.common-details-img {
  width: 91px;
  height: 59px;
  border-radius: 4px;
  border: 1px solid #D7DDE5;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/CommonMchDetails.vue